export const clearLocalStorageExcept = (keysToPreserve: Array<string> = []): Record<string, string | null> => {
  const preserved: Record<string, string | null> = {};
  keysToPreserve.forEach(key => {
    preserved[key] = localStorage.getItem(key);
  });
  localStorage.clear();
  keysToPreserve.forEach(key => {
    const value = preserved[key];
    if (value !== null && value !== undefined) localStorage.setItem(key, value);
  });
  return preserved;
};
